import {useCopyToClipboard} from 'react-use';
import {useState} from 'react';
import {Button, Banner} from '@sail/ui';
import {useAnalytics} from '@stripe-internal/inline-data';
import {FormattedMessage, defineMessages} from 'react-intl';
import {Payout} from './MerchantPayoutStatus';

const messages = defineMessages({
  copyTraceId: {
    id: 'mse_inline_data.merchant_payout_status.copy_trace_id',
    description: 'Button text for copying a trace ID',
    defaultMessage: 'Copy Trace ID',
  },
  copiedToClipboard: {
    id: 'mse_inline_data.merchant_payout_status.copied_to_clipboard',
    description: 'Message after user copies trace id to clipboard.',
    defaultMessage: 'Copied to clipboard',
  },
  copyToClipboardError: {
    id: 'mse_inline_data.merchant_payout_status.copy_to_clipboard_error',
    description:
      'Message after user unsuccessfully copies trace id to clipboard due to browser permissions.',
    defaultMessage:
      'Unable to copy to your clipboard due to browser permissions',
  },
});

export const TraceIdCopyButton = ({payout}: {payout: Payout}) => {
  const analytics = useAnalytics();
  const [copiedText, copy] = useCopyToClipboard();
  const [copied, setCopied] = useState<boolean | null>(null);

  return (
    <>
      <Button
        data-testid="cta-button"
        type="secondary"
        css={{width: 'fill', size: 'small'}}
        onClick={() => {
          analytics.action('uh_merchant_payout_status_copied_trace_id');
          setCopied(true);
          setTimeout(() => setCopied(false), 5000);
          const text = payout?.trace_id || '';
          copy(text);
        }}
      >
        <FormattedMessage {...messages.copyTraceId} />
      </Button>
      {copied && copiedText ? (
        <Banner
          description={<FormattedMessage {...messages.copiedToClipboard} />}
        />
      ) : null}
      {copied && !copiedText ? (
        <Banner
          description={<FormattedMessage {...messages.copyToClipboardError} />}
        />
      ) : null}
    </>
  );
};
